let dirPath = 'games/page040_game0/';
let dirAudio = 'games/page040_game0/audio/';

let configGame = {
  autoCheckAllCorrect: true,
  removeInCorrects: true,
  correctBlock: false,
  rulesGame: {
    otherProperty: {
      sounds: [{ src: dirPath + 'audio/click.mp3', id: 'mouseup' }],
    },
    // itemsConfig: { shuffle: false, block: true },
    items: [
      {
        idGroup: 'source',
        idItem: 's01',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't01',
            correct: [{ idGroup: 'source', idItem: 's01' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's02',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't02',
            correct: [{ idGroup: 'source', idItem: 's02' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's03',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't03',
            correct: [{ idGroup: 'source', idItem: 's03' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's04',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't04',
            correct: [{ idGroup: 'source', idItem: 's04' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's05',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't05',
            correct: [{ idGroup: 'source', idItem: 's05' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's06',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't06',
            correct: [{ idGroup: 'source', idItem: 's06' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's07',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't07',
            correct: [{ idGroup: 'source', idItem: 's07' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's08',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't08',
            correct: [{ idGroup: 'source', idItem: 's08' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's09',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't09',
            correct: [{ idGroup: 'source', idItem: 's09' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's10',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't10',
            correct: [{ idGroup: 'source', idItem: 's10' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's11',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't11',
            correct: [{ idGroup: 'source', idItem: 's11' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's12',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't12',
            correct: [{ idGroup: 'source', idItem: 's12' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's13',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't13',
            correct: [{ idGroup: 'source', idItem: 's13' }],
          },
        ],
      },
      {
        idGroup: 'source',
        idItem: 's14',
        itemsConfig: { shuffle: true, block: true },
        items: [
          {
            idGroup: 'target',
            idItem: 't14',
            correct: [{ idGroup: 'source', idItem: 's14' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: { pos: { width: 792 }, margin: { right: 4 } },
      background: {
        text: {
          font: 'Garamond',
          size: '32px',
          textAlign: 'center',
          textBaseline: 'middle',
        },
      },
    },
    groups: [
      {
        idGroup: 'target',
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 205 - 58, y: 181 - 38 },
            { x: 205 - 58, y: 338 - 38 },
            { x: 398 - 58, y: 181 - 38 },
            { x: 398 - 58, y: 338 - 38 },
            { x: 591 - 58, y: 181 - 38 },
            { x: 591 - 58, y: 338 - 38 },
            { x: 591 - 58, y: 494 - 38 },
            { x: 591 - 58, y: 651 - 38 },
            { x: 591 - 58, y: 808 - 38 },
            { x: 784 - 58, y: 181 - 38 },
            { x: 784 - 58, y: 338 - 38 },
            { x: 784 - 58, y: 494 - 38 },
            { x: 784 - 58, y: 651 - 38 },
            { x: 784 - 58, y: 808 - 38 },
          ],
        },
        otherProperty: {
          hooks: {
            autoResize: true,
            background: { color: 'rgba(255,255,255,0.01)' },
            positions: { pos: { width: 96, height: 96 } },
            items: [{ id: 'h01' }],
          },
        },
        items: [
          {
            id: 't01',
            otherProperty: {
              audio: ['a01'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't02',
            otherProperty: {
              audio: ['a02'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't03',
            otherProperty: {
              audio: ['a03'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't04',
            otherProperty: {
              audio: ['a04'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't05',
            otherProperty: {
              audio: ['a05'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't06',
            otherProperty: {
              audio: ['a06'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't07',
            otherProperty: {
              audio: ['a07'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't08',
            otherProperty: {
              audio: ['a08'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't09',
            otherProperty: {
              audio: ['a09'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't10',
            otherProperty: {
              audio: ['a10'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't11',
            otherProperty: {
              audio: ['a11'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't12',
            otherProperty: {
              audio: ['a12'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't13',
            otherProperty: {
              audio: ['a13'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
          {
            id: 't14',
            otherProperty: {
              audio: ['a14'],
              hooks: { background: { image: { color: 'rgba(0,0,0,0.01)' } } },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        positions: {
          type: 'absolute',
          autoFit: true,
          fixTab: [
            { x: 863, y: 202 }, // banan
            { x: 1713, y: 191 }, // pear
            { x: 1394, y: 782 }, // cherry
            { x: 1075, y: 470 }, // ;lemon
            { x: 910, y: 713 }, // pepper
            { x: 1078, y: 138 }, // carrot
            { x: 1489, y: 450 }, // tomato
            { x: 1498, y: 136 }, // dog
            { x: 1277, y: 468 }, // cat
            { x: 1142, y: 800 }, // mouse
            { x: 1267, y: 179 }, // fish
            { x: 1628, y: 762 }, // hamster
            { x: 845, y: 446 }, // parrot
            { x: 1706, y: 519 }, // canary
          ],
        },
        itemsConfig: {
          background: { color: 'rgba(255,255,255,0.01)' },
          positions: {
            pos: { width: 219, height: 219 },
            // rows: 1,
            // margin: { right: 38 },
          },
        },
        // positions: {
        //   type: 'absolute',
        //   pos: { x: 80, y: 920 },
        // },
        items: [
          {
            id: 's01',
            background: {
              image: { src: dirPath + 'img/banana.webp', pos: { width: 142, height: 160, x: (160 - 142) / 2, y: 0 } },
            },
            positions: { pos: { width: 160, height: 160 } },
          },
          {
            id: 's02',
            background: {
              image: { src: dirPath + 'img/pear.webp', pos: { width: 105, height: 169, x: (169 - 105) / 2, y: 0 } },
            },
            positions: { pos: { width: 169, height: 169 } },
          },
          {
            id: 's03',
            background: {
              image: { src: dirPath + 'img/cherry.webp', pos: { width: 131, height: 135, x: 2, y: 0 } },
            },
            positions: { pos: { width: 135, height: 135 } },
          },
          {
            id: 's04',
            background: {
              image: { src: dirPath + 'img/lemon.webp', pos: { width: 158, height: 133, x: 0, y: (158 - 133) / 2 } },
            },
            positions: { pos: { width: 158, height: 158 } },
          },
          {
            id: 's05',
            background: {
              image: { src: dirPath + 'img/pepper.webp', pos: { width: 136, height: 176, x: (176 - 136) / 2, y: 0 } },
            },
            positions: { pos: { width: 176, height: 176 } },
          },
          {
            id: 's06',
            background: {
              image: { src: dirPath + 'img/carrot.webp', pos: { width: 159, height: 178, x: (178 - 159) / 2, y: 0 } },
            },
            positions: { pos: { width: 178, height: 178 } },
          },
          {
            id: 's07',
            background: {
              image: { src: dirPath + 'img/tomato.webp', pos: { width: 154, height: 154, x: 0, y: 0 } },
            },
            positions: { pos: { width: 154, height: 154 } },
          },
          {
            id: 's08',
            background: {
              image: { src: dirPath + 'img/dog.webp', pos: { width: 152, height: 199, x: (199 - 152) / 2, y: 0 } },
            },
            positions: { pos: { width: 199, height: 199 } },
          },
          {
            id: 's09',
            background: {
              image: { src: dirPath + 'img/cat.webp', pos: { width: 177, height: 181, x: (181 - 177) / 2, y: 0 } },
            },
            positions: { pos: { width: 181, height: 181 } },
          },
          {
            id: 's10',
            background: {
              image: { src: dirPath + 'img/mouse.webp', pos: { width: 170, height: 120, x: 0, y: (170 - 120) / 2 } },
            },
            positions: { pos: { width: 170, height: 170 } },
          },
          {
            id: 's11',
            background: {
              image: { src: dirPath + 'img/fish.webp', pos: { width: 183, height: 167, x: 0, y: (183 - 167) / 2 } },
            },
            positions: { pos: { width: 183, height: 183 } },
          },
          {
            id: 's12',
            background: {
              image: { src: dirPath + 'img/hamster.webp', pos: { width: 104, height: 146, x: (146 - 104) / 2, y: 0 } },
            },
            positions: { pos: { width: 146, height: 146 } },
          },
          {
            id: 's13',
            background: {
              image: { src: dirPath + 'img/parrot.webp', pos: { width: 165, height: 177, x: (177 - 165) / 2, y: 0 } },
            },
            positions: { pos: { width: 177, height: 177 } },
          },
          {
            id: 's14',
            background: {
              image: { src: dirPath + 'img/canary.webp', pos: { width: 137, height: 135, x: 1, y: 0 } },
            },
            positions: { pos: { width: 137, height: 137 } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  // blockCheck: true,
  mainImage: {
    imagePath: dirPath + 'img/bcg.webp',
  },
  fullscreen: true,
  mixinEngine: 'dnd',
  mbAudioItemData: [
    {
      id: 'a01',
      src: dirAudio + '43_banana.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: dirAudio + '44_pear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: dirAudio + '45_cherry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: dirAudio + '46_lemon.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a05',
      src: dirAudio + '47_pepper.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a06',
      src: dirAudio + '48_carrot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a07',
      src: dirAudio + '49_tomato.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a08',
      src: dirAudio + '50_dog.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a09',
      src: dirAudio + '51_cat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a10',
      src: dirAudio + '52_mouse.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a11',
      src: dirAudio + '53_fish.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a12',
      src: dirAudio + '54_hamster.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a13',
      src: dirAudio + '55_parrot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
    {
      id: 'a14',
      src: dirAudio + '56_canary.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page040_game0/img/audioOn.png', iconOff: 'games/page040_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 16,
        x: -60,
      },
      width: '67px',
      height: '67px',
      unit: 'px',
    },
  ],
  configGame: configGame,
};

export default dataConfig;
